<template>
	<div>
		<!-- 顶部搜索区 -->
		<el-card>
			<el-form :model="form" ref="userform" :inline="true">
				<el-form-item label="用户姓名:">
					<el-input placeholder="请输入用户姓名" v-model="form.nickname" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="用户手机:">
					<el-input placeholder="请输入用户手机" v-model="form.tel" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="调整编号:">
					<el-input placeholder="请输入调整编号" v-model="form.orderid" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="状态:">
					<el-select v-model="formtype" placeholder="请选择状态">
						<el-option label="待处理" value="3"></el-option>
						<el-option label="已处理" value="1"></el-option>
						<el-option label="已拒绝" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="调整日期:">
					<el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm()">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button @click="resetForm()">重置</el-button>
				</el-form-item>
				<download-excel style="margin-left: 13px;" class="export-excel-wrapper" :data="tableData" :fields="json_fields"
					:header="title" type="xls" name="提现统计导出.xls">
					<el-button type="success">导出当前页</el-button>
				</download-excel>
			</el-form>
		</el-card>
		<!-- 内容主列表 -->
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="uid" label="用户编号" width="50">
				</el-table-column>
				<el-table-column prop="nickname" label="用户昵称">
				</el-table-column>
				<el-table-column prop="log_user_name" label="用户实名">
					<template slot-scope="scope">
						<el-button size="small" @click="submituserinfo(scope.row)">{{scope.row.enter_name}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="tel" label="手机号">
				</el-table-column>
				<el-table-column prop="user_idcard" label="身份证号">
				</el-table-column>
				<el-table-column prop="log_time" label="提现平台">
					<template slot-scope="scope">
						<div>支付宝</div>
					</template>
				</el-table-column>
				<el-table-column prop="account" label="提现账号">
				</el-table-column>
				<el-table-column prop="price" label="提现金额">
				</el-table-column>
				<el-table-column prop="order_num" label="订单编号">
				</el-table-column>
				<el-table-column prop="start_time" label="提现时间">
				</el-table-column>
				<el-table-column  label="类型">
					<template slot-scope="scope">
						<div v-if="scope.row.pay_type == 1" style="">
							灵活就业
						</div>
						<div v-else-if="scope.row.pay_type == 2" >
							个人申报
						</div>
						<div v-else-if="scope.row.pay_type == 3" >
							充值退款
						</div>
						<div v-else >
							个人申报
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="end_time" label="处理时间">
				</el-table-column>
				<el-table-column prop="start_time" label="操作" width="200">
					<template slot-scope="scope">
						<div v-if="scope.row.state == 0" style="">
							<!-- <el-button type="primary" plain size="small" @click="openagree(scope.row)">kmk同意</el-button> -->
							<el-button type="primary" plain size="small" @click="openagree(scope.row)">同意</el-button>
							<el-button type="danger" plain size="small" @click="openrefuse(scope.row)">拒绝</el-button>
						</div>
						<div v-else-if="scope.row.state == 1">
							<el-button size="small">已处理</el-button>
						</div>
						<div v-else>
							<el-button size="small">已拒绝</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
		<el-dialog title="用户历史交易列表" :visible.sync="dialogFormVisible">
			<div>
				用户姓名：<el-input v-model="userinfo.name" disabled style="width: 150px;"></el-input>
				用户账户：<el-input v-model="userinfo.id" disabled style="width: 100px;"></el-input>
				可用余额：<el-input v-model="userinfo.money" disabled style="width: 100px;"></el-input>
			</div>
			<div style="margin: 10px 0;">
				用户手机：<el-input v-model="userinfo.tel" disabled style="width: 150px;"></el-input>
				身份证号：<el-input v-model="userinfo.idcard" disabled style="width: 200px;"></el-input>
			</div>
			<el-button type="primary" plain size="small" @click="getuserjustincome()">筛选充值状态</el-button>
			<el-table :data="userinfolist" style="width: 100%"  height="450">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="start_time" label="日期">
				</el-table-column>
				<el-table-column prop="price" label="交易金额">
				</el-table-column>
				<el-table-column prop="bbeforewithdrawal" label="交易前余额">
				</el-table-column>
				<el-table-column prop="endwithdrawal" label="交易后余额">
				</el-table-column>
				<el-table-column prop="log_time" label="交易状态" width="150">
					<template slot-scope="scope">
						<!-- <div>
							{{scope.row.state == '1'? "成功":scope.row.state == '0'?'进行中':'已拒绝'}}
						</div> -->
						<div v-if="scope.row.type ==0" >
							<div v-if="scope.row.zfbstate.code == 1" style="color: red;">
								
								<p>{{ scope.row.zfbstate.message }}</p>
							</div>
							<div v-else style="color: green;">
								
								<p>{{ scope.row.zfbstate.message }}</p>
								<!-- <p v-if="scope.row.state == '1'">
									<el-button type="primary" plain size="small" @click="rechargeback(scope.row.id)">点击回退金额</el-button>
								</p> -->
							</div>
							<div>付款账号：{{ scope.row.zfbstate.buyer_logon_id }}</div>
						</div>
						<div v-else>
							非充值交易
						</div>
					</template>
				</el-table-column>
				
				
				<el-table-column prop="remark" label="交易备注" ></el-table-column>
				<el-table-column  label="查看详情" >
					<template slot-scope="scope">
						<div style="cursor: pointer;" v-if="scope.row.type ==5" @click="golook(scope.row)">
							委托收入明细
						</div>
						<div style="cursor: pointer;" v-else-if="scope.row.type ==12" @click="golookreward(scope.row)">
							打赏收入明细
						</div>
						<div style="cursor: pointer;" v-else-if="scope.row.type ==0||scope.row.type ==305" >
							交易方式：{{scope.row.pay_kind}}
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div style="height: 80px;">
				<Pageing :page="userinfopage" :size="userinfosize" :total="userinfototal"
					@current-change="handleChangeuserPage"></Pageing>
			</div>
		</el-dialog>
		<el-dialog title="交易委托详情" :visible.sync="golookentrustform">
			<div>
				委托名称：<a style="text-decoration: none;margin-right: 20px;" :href="'https://chuoooo.com/delegatedetails?id='+enteruser.id" target="_blank">{{enteruser.entername}}</a>
				<!-- <el-input v-model="enteruser.entername" disabled style="width: 150px;"></el-input> -->
				甲方昵称：<a style="text-decoration: none;margin-right: 20px;">{{ enteruser.enteruser }}</a>
				<!-- <el-input v-model="enteruser.enteruser" disabled style="width: 200px;"></el-input> -->
				甲方姓名：<router-link :to="'/rwlist?name='+ enteruser.realname" target="_blank" style="text-decoration: none;">{{enteruser.realname}}</router-link>
				<!-- 甲方姓名：<el-button size="small" @click="gouserinfo()">{{enteruser.realname}}</el-button> -->
				<!-- <el-input v-model="enteruser.realname" @click="gouserinfo(enteruser.realname)" style="width: 200px;"></el-input> -->
			</div>
			
			<el-table :data="enterinfo" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="start_time" label="日期">
				</el-table-column>
				<el-table-column prop="price" label="交易金额">
				</el-table-column>
				<el-table-column prop="bbeforewithdrawal" label="交易前余额">
				</el-table-column>
				<el-table-column prop="endwithdrawal" label="交易后余额">
				</el-table-column>
				<el-table-column prop="pay_kind" label="交易类型">
				</el-table-column>
				
				<el-table-column prop="remark" label="交易备注" ></el-table-column>
				
			</el-table>
			<div style="height: 80px;">
				<Pageing :page="enterpage" :size="10" :total="entertotal"
					@current-change="handleChangeenterPage"></Pageing>
			</div>
		</el-dialog>
		<el-dialog title="打赏交易详情" :visible.sync="golookrewardform">
			<div>
				甲方昵称：<el-input v-model="enteruser.enteruser" disabled style="width: 200px;"></el-input>
				甲方姓名：<router-link :to="'/rwlist?name='+ enteruser.realname" target="_blank" style="text-decoration: none;">{{enteruser.realname}}</router-link>
				<!-- <el-input v-model="enteruser.realname" disabled style="width: 200px;"></el-input> -->
			</div>
			
			<el-table :data="enterinfo" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="start_time" label="日期">
				</el-table-column>
				<el-table-column prop="price" label="交易金额">
				</el-table-column>
				<el-table-column prop="bbeforewithdrawal" label="交易前余额">
				</el-table-column>
				<el-table-column prop="endwithdrawal" label="交易后余额">
				</el-table-column>
				<el-table-column prop="pay_kind" label="交易类型">
				</el-table-column>
				
				<el-table-column prop="remark" label="交易备注" ></el-table-column>
				
			</el-table>
			<div style="height: 80px;">
				<Pageing :page="enterpage" :size="10" :total="entertotal"
					@current-change="handleChangeenterPage"></Pageing>
			</div>
		</el-dialog>
		<el-dialog title="处理提现申请" :visible.sync="rechargeform">
			<el-form :model="forminfo">

				<el-form-item label="用户昵称" :label-width="formLabelWidth">
					<el-input v-model="forminfo.nickname" disabled autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="真实姓名" :label-width="formLabelWidth">
					<el-input v-model="forminfo.enter_name" disabled autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="手机号码" :label-width="formLabelWidth">
					<el-input v-model="forminfo.tel" disabled autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="身份证号" :label-width="formLabelWidth">
					<el-input v-model="forminfo.user_idcard" disabled autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="提现账号" :label-width="formLabelWidth">
					<el-input v-model="forminfo.account" disabled autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="提现金额" :label-width="formLabelWidth">
					<el-input v-model="forminfo.price" disabled autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="rechargeform = false">取 消</el-button>
				<el-button :loading="loading" type="primary" @click="submitrechargeform">{{text}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	
	import DownloadExcel from 'vue-json-excel'
	import Cookie from 'js-cookie'
	import Pageing from '../../components/page/page.vue'
	import {
		getadjustuserinfo,
		submitadd,
		getrechargelist,
		rechargerefuse,
		rechargeback,
		churechargeagree,
		entrustinfo,
		rewardinfo
	} from '../../api/recharge.js'
	export default {
		components: {
			Pageing,
			DownloadExcel
		},
		data() {
			return {
				title: '提现统计导出',
				json_fields: {
					"姓名": 'enter_name',
					"时间":"start_time",
					"提现金额":"price",
					"手机号":"tel",
					"身份证":"user_idcard",
					"类型":"declaretype",
					"状态":"state_type"
				},
				loading:false,
				text:'确定',
				formLabelWidth: '120px',
				dialogFormVisible: false,
				rechargeform: false,
				golookentrustform: false,
				golookrewardform:false,
				page: 1,
				size: 10,
				total: 0,
				tableData: [],
				runmoney: 0,
				checkAll: false,
				formtype: '',
				userpaytype:'',
				form: {
					nickname: '',
					tel: '',
					orderid: '',
					time: '',
				},
				moneyform: {
					incomemoney: 0,
					runwater: 0,
					paymoney: 0,
				},
				forminfo: {},
				userinfo: {
					name: '',
					id: '',
					tel: '',
					idcard: '',
					money: '0'
				},
				useraddinfo: {
					user: '',
					money: '',
					remark: ''
				},
				userinfolist: [],
				userinfoid: '',
				userinfopage: 1,
				userinfosize: 10,
				userinfototal: 0,
				enterinfo :[],
				enteruser:{
					'entername':'',
					'enteruser':'',
					'realname':'',
					'id':''
				},
				entertotal:0,
				enterpage:1,
				parentorder:''
			};
		},
		mounted() {
			this.getuserlist()
		},
		methods: {
			openagree(e) {
				
				this.forminfo = e
				this.rechargeform = true
			},
			golookreward(val){
				
				this.golookrewardform = true
				this.parentorder = val.parent_order_num
				rewardinfo({
					'order':this.parentorder,
					'page':this.enterpage
				}).then(res=>{
					
					 this.enteruser.enteruser = res.usernick
					 this.enteruser.realname = res.realname
					 this.enterinfo = res.list
					
				})
			},
			gouserinfo(){
				const name = this.enteruser.realname
				this.$router.push({  
					name: 'recharge',  
					params: { name },  
					replace: true 
				});  
			},
			golook(val){
				this.golookentrustform = true
				//this.parentorder == '' ? this.parentorder = val.parent_order_num:this.parentorder = this.parentorder
				this.parentorder = val.parent_order_num
				
				entrustinfo({
					'order':this.parentorder,
					'page':this.enterpage
				}).then(res=>{
					//console.log(`output->res`,res)
					this.enteruser.entername = res.entername
					this.enteruser.enteruser = res.usernick
					this.enteruser.realname = res.realname
					this.enteruser.id = res.id
					this.enterinfo = res.list.data
					this.entertotal  = res.list.total
					this.enterpage  = res.list.current_page
				})
				
			},
			//确认提现
			submitrechargeform() {
				
				this.loading = true
				this.text = '处理中'
				churechargeagree({
					token: Cookie.get('token'),
					order_id: this.forminfo.id
				}).then(res => {
					if (res.code == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.rechargeform = false
						this.getuserlist()
					}else{
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
					this.loading = false
					this.text = '确定'
				})
			},
			openrefuse(e) {
				this.$alert('确认拒绝该账户提现！', '确认拒绝', {
					confirmButtonText: '确定',
					callback: action => {
						if (action == 'confirm') {
							rechargerefuse({
								token: Cookie.get('token'),
								order_id: e.id
							}).then(res => {
								if (res.code == 200) {
									this.$message({
										message: '拒绝成功',
										type: 'success'
									});
									this.getuserlist()
								}

							})
						} else {
							console.log('取消操作');
						}


					}
				});
			},
			//用户点击详情
			submituserinfo(e) {
				
				this.userinfoid = e.uid
				this.getuserinfo()
				this.dialogFormVisible = true
			},
			getuserjustincome(){
				this.userpaytype = 1;
				this.getuserinfo()
			},
			getuserinfo() {
				getadjustuserinfo({
					uid: this.userinfoid,
					page: this.userinfopage,
					type: this.userpaytype
				}).then(res => {
					this.userinfo.name = res.name
					this.userinfo.id = res.user
					this.userinfo.tel = res.tel
					this.userinfo.idcard = res.idcard
					this.userinfolist = res.list.data
					this.userinfototal = res.list.total
					this.userinfo.money = res.money
				})
			},
			rechargeback(id){
				rechargeback({
					'id':id
				}).then(res =>{
					console.log(`output->res`,res)
					if(res.code ==200){
						this.$message({
							message: res.msg,
							type: 'success'
						});
					}else{
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
					this.getuserinfo()
				})
			},

			sumbmitadd() {
				submitadd({
					'data': this.useraddinfo
				}).then(res => {
					
					//this.resetuseradd()
				})
			},
			getuserlist() {
				getrechargelist({
					page: this.page,
					where: this.form,
					type: this.formtype
				}).then(res => {

					this.tableData = res.list
					this.total = res.total

				})

			},

			submitForm() {
				this.getuserlist()
			},
			handleChangePage(val) {
				this.page = val
				this.getuserlist()
			},
			handleChangeuserPage(val) {
				this.userinfopage = val
				this.getuserinfo()
			},
			handleChangeenterPage(val){
				this.enterpage = val
				
				this.golook(this.parentorder)
			},
			resetForm() {
				this.$refs.userform.resetFields()
				this.form.nickname = ''
				this.form.tel = ''
				this.formtype = ''
				this.form.orderid = ''
				this.form.time = ''
				this.getuserlist()
			},

			close() {
				this.resetuseradd()
			},
			resetuseradd() {
				this.useraddinfo.user = ''
				this.useraddinfo.money = ''
				this.useraddinfo.remark = ''
			}

		}
	};
</script>

<style lang="less" scoped>
	.runmoney {
		display: flex;
		flex-direction: column;
		align-items: center;

		ul {
			display: flex;

			li {
				text-align: center;
				margin: 0 20px;
			}
		}
	}
</style>
